import "./sidebar.css";
import {
  LineStyle,
  Timeline,
  TrendingUp,
  PermIdentity,
  Storefront,
  BarChart,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";
export default function Sidebar() {
  return (
    <div className="sidebar">
      <div className="sidebarWrapper">
        <div className="sidebarMenu">
          <div className="sidebarImage">
            <img src={logo} width="110" alt="logo" />
          </div>

          <h3 className="sidebarTitle">Dashboard</h3>
          <ul className="sidebarList">
            <Link to="/" className="link">
              <li className="sidebarListItem">
                <LineStyle className="sidebarIcon" />
                Home
              </li>
            </Link>
            <li className="sidebarListItem">
              <Timeline className="sidebarIcon" />
              Analytics
            </li>
            <li className="sidebarListItem">
              <TrendingUp className="sidebarIcon" />
              Sales
            </li>
          </ul>
        </div>
        <div className="sidebarMenu">
          <h3 className="sidebarTitle">Quick Menu</h3>
          <ul className="sidebarList">
            <Link to="/users" className="link">
              <li className="sidebarListItem">
                <PermIdentity className="sidebarIcon" />
                İnfluencer Liste
              </li>
            </Link>
            <Link to="/products" className="link">
              <li className="sidebarListItem">
                <Storefront className="sidebarIcon" />
                Markalar
              </li>
            </Link>

            <Link to="/advert" className="link">
              <li className="sidebarListItem">
                <BarChart className="sidebarIcon" />
                İlan
              </li>
            </Link>
            <Link to="/advertList" className="link">
              <li className="sidebarListItem">
                <BarChart className="sidebarIcon" />
                İlan Listesi
              </li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
}
